
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("9QvUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $13bb23ac78effffb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $4H1Ql = parcelRequire("4H1Ql");

var $NT2w1 = parcelRequire("NT2w1");

var $2mPpz = parcelRequire("2mPpz");

var $gwFzn = parcelRequire("gwFzn");

var $2xYsH = parcelRequire("2xYsH");

var $hnA4H = parcelRequire("hnA4H");
const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $gwFzn.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $NT2w1.default), {
        placementId: placementId,
        consumptionType: "local",
        onEvent: onEvent,
        disableInitialData: disableInitialData,
        children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2xYsH.default), {
                analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                placementId: placementId,
                onError: sharedOnEvent,
                fallback: ErrorFallback,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(MemoizedPlacement, {
                    initialData: initialData,
                    context: context,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore - Confluence Local Consumption
                    errorFallback: ErrorFallback,
                    ...stableLocalPlacementProps,
                    children: children
                })
            })
    });
};
var $13bb23ac78effffb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $gwFzn.memo)($13bb23ac78effffb$var$Placement);

});
parcelRegister("NT2w1", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ab3a0c2f45d583$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $ffCOo = parcelRequire("ffCOo");

var $PAiZW = parcelRequire("PAiZW");
var $6yHRM = parcelRequire("6yHRM");
var $4H1Ql = parcelRequire("4H1Ql");

var $3NyPa = parcelRequire("3NyPa");
var $h6POP = parcelRequire("h6POP");

var $kO3gu = parcelRequire("kO3gu");

var $gwFzn = parcelRequire("gwFzn");

var $dE7qQ = parcelRequire("dE7qQ");

var $5dPMD = parcelRequire("5dPMD");

var $dug7n = parcelRequire("dug7n");
const $80ab3a0c2f45d583$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    return (0, $gwFzn.useMemo)(()=>disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
const $80ab3a0c2f45d583$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $gwFzn.useMemo)(()=>isUFOEnabled ? new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $gwFzn.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $gwFzn.useMemo)(()=>({
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($80ab3a0c2f45d583$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $80ab3a0c2f45d583$export$2e2bcd8739ae039 = $80ab3a0c2f45d583$var$Placement;
const $80ab3a0c2f45d583$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
};

});
parcelRegister("3NyPa", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $959aa8656bf0972c$export$96236906ebaa7f87);

var $jTlSd = parcelRequire("jTlSd");

var $koKWt = parcelRequire("koKWt");
const $959aa8656bf0972c$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jTlSd.MessagePerformanceTracker,
    PlacementPerformanceTracker: $koKWt.PlacementPerformanceTracker
};

});
parcelRegister("jTlSd", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $71d7f78b2ff13923$export$ae5c73c7c4f454e6);

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");

var $haNjI = parcelRequire("haNjI");
class $71d7f78b2ff13923$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("haNjI", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $ac68ec5e99dfa5a8$export$6d482cfa20c9d220);
const $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $ac68ec5e99dfa5a8$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("koKWt", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $f3e04d171a04c0ba$export$8b48c2105ba0b35a);

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");

var $haNjI = parcelRequire("haNjI");
const $f3e04d171a04c0ba$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $9NDUe.ExperienceTypes).Load,
    platform: {
        component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $f3e04d171a04c0ba$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).PLACEMENT, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).PLACEMENT}.${placementId}`, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("dE7qQ", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6);
const $2d2adb07a8ea6d4a$export$85183a312807388d = 'postOffice';
const $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6 = 'post-office-frontend';

});

parcelRegister("dug7n", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $f2f503b4228c54ff$export$83d6c58b7ab7ae67);

var $bnKhH = parcelRequire("bnKhH");
var $c3xd8 = parcelRequire("c3xd8");

var $gwFzn = parcelRequire("gwFzn");
const $f2f503b4228c54ff$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    return (0, $gwFzn.useMemo)(()=>(0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});


parcelRegister("2mPpz", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $479bf4f98cf9c8c7$export$8a57effc6307f916);

var $byfJM = parcelRequire("byfJM");
const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("byfJM", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $573f4005c25c6dbc$export$8a57effc6307f916);

var $7UHDa = parcelRequire("7UHDa");

var $4H1Ql = parcelRequire("4H1Ql");

var $a8wvv = parcelRequire("a8wvv");

var $9dOtv = parcelRequire("9dOtv");

var $eXPKf = parcelRequire("eXPKf");
var $MnX4h = parcelRequire("MnX4h");

var $2HRxT = parcelRequire("2HRxT");
const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $MnX4h.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("9dOtv", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $94fea169e2cb8de7$export$3d127465d22fe4e5);

var $gwFzn = parcelRequire("gwFzn");
const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $gwFzn.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});



parcelRegister("2xYsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1916333c8b5a116e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $1DWH0 = parcelRequire("1DWH0");

var $gwFzn = parcelRequire("gwFzn");
class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
var $1916333c8b5a116e$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);

});

parcelRegister("hnA4H", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $f3b0e253e752d4df$export$85183a312807388d);
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';

});


parcelRegister("cyz5M", function(module, exports) {

$parcel$export(module.exports, "MaybeSuspenseBoundary", () => $765afc5340447923$export$9750eb54d7c7e789);
$parcel$export(module.exports, "asMessageRenderer", () => $765afc5340447923$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $7UHDa = parcelRequire("7UHDa");

var $c6GJD = parcelRequire("c6GJD");

var $4H1Ql = parcelRequire("4H1Ql");

var $3NyPa = parcelRequire("3NyPa");
var $h6POP = parcelRequire("h6POP");

var $hOVIX = parcelRequire("hOVIX");

var $3Shv6 = parcelRequire("3Shv6");

var $2amyA = parcelRequire("2amyA");
var $aEUWC = parcelRequire("aEUWC");
var $jVzfH = parcelRequire("jVzfH");
var $fUB5z = parcelRequire("fUB5z");
var $2HRxT = parcelRequire("2HRxT");

var $hyvHs = parcelRequire("hyvHs");

var $gwFzn = parcelRequire("gwFzn");

var $lVEBn = parcelRequire("lVEBn");
const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $gwFzn.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, SuspenseBoundary: SuspenseBoundary = (0, $gwFzn.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $4H1Ql.useStableObject)(recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $4H1Ql.useStableObject)(postOffice ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $gwFzn.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $gwFzn.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $gwFzn.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $4H1Ql.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $c6GJD.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jVzfH.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $765afc5340447923$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                        onError: onError,
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lVEBn.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Shv6.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails,
                                journeyId: journeyId,
                                journeyTriggerId: journeyTriggerId
                            },
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hyvHs.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                                                onError: onError,
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("lVEBn", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $5d2b57d7f45b3b6a$export$8db7ba034addcd65);

var $7UHDa = parcelRequire("7UHDa");

var $c6GJD = parcelRequire("c6GJD");

var $7XIdu = parcelRequire("7XIdu");

var $3zCGc = parcelRequire("3zCGc");

var $gwFzn = parcelRequire("gwFzn");
const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $7UHDa.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("6Ht9d", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $876859b1b10b173e$export$5523c5f3222291d0);

var $gwFzn = parcelRequire("gwFzn");

var $gAOec = parcelRequire("gAOec");
const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $gwFzn.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});

parcelRegister("jQRRW", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $221a2b03be5b44a4$export$a5d940130f33be3f);

var $7UHDa = parcelRequire("7UHDa");

var $5pS3b = parcelRequire("5pS3b");
const $221a2b03be5b44a4$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5pS3b.IntlProvider), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            })
        });
    };

});
parcelRegister("5pS3b", function(module, exports) {

$parcel$export(module.exports, "IntlProvider", () => $b2d267b4c02f41c6$export$480518999dfc4151);

var $7UHDa = parcelRequire("7UHDa");

var $7XIdu = parcelRequire("7XIdu");

var $hlhtG = parcelRequire("hlhtG");
var $dBxQj = parcelRequire("dBxQj");

var $ewi8o = parcelRequire("ewi8o");
function $b2d267b4c02f41c6$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $dBxQj.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $b2d267b4c02f41c6$export$480518999dfc4151(props) {
    const { locale: locale } = $b2d267b4c02f41c6$var$useFetchLocale();
    const messages = (0, $ewi8o.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("ewi8o", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $9f428f426036dbfa$export$2641ec9a2025a81f);

var $7XIdu = parcelRequire("7XIdu");

var $gwFzn = parcelRequire("gwFzn");
const $9f428f426036dbfa$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $gwFzn.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});



parcelRegister("8SCD0", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $e6c9af975b930043$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ineA9 = parcelRequire("ineA9");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6c9af975b930043$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;































const $e6c9af975b930043$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4gCuh")));
        case 'da':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("aKB6h")));
        case 'de':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3xTit")));
        case 'en-GB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("czu29")));
        case 'en-US':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("e5mYd")));
        case 'en-XA':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("dIcAj")));
        case 'en-XB':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("iIKoF")));
        case 'en-ZZ':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("jOmZE")));
        case 'en':
            return $e6c9af975b930043$var$importHelper(await Promise.resolve((parcelRequire("ineA9"))));
        case 'es':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("fFRNT")));
        case 'et':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("32noh")));
        case 'fi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("fxuYz")));
        case 'fr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("l3Eye")));
        case 'hu':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("f7ky6")));
        case 'it':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("7as9r")));
        case 'ja':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("76QyX")));
        case 'ko':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4Qc7k")));
        case 'nb':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("2MU1N")));
        case 'nl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("4YZVZ")));
        case 'pl':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("it51F")));
        case 'pt-BR':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1F6qu")));
        case 'ro':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hROdq")));
        case 'ru':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("1LJw7")));
        case 'sv':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("huY3L")));
        case 'th':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("kVYlY")));
        case 'tr':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("8QxWk")));
        case 'uk':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("hVm6V")));
        case 'vi':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("i2Gvh")));
        case 'zh-CN':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3rvZL")));
        case 'zh-TW':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3A0MI")));
        case 'zh':
            return $e6c9af975b930043$var$importHelper(await (parcelRequire("3rvZL")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ineA9));
    }
};

});
parcelRegister("4gCuh", function(module, exports) {

let $31b682d549a0fd9b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $31b682d549a0fd9b$var$load("i5eMd").then(()=>parcelRequire('bvjlk'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});



parcelRegister("aKB6h", function(module, exports) {

let $7d3afa9d7cd5044f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d3afa9d7cd5044f$var$load("4UPfH").then(()=>parcelRequire('IzetR'));

});

parcelRegister("3xTit", function(module, exports) {

let $294f5900d1665cc6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $294f5900d1665cc6$var$load("gd4qs").then(()=>parcelRequire('b60fG'));

});

parcelRegister("czu29", function(module, exports) {

let $92700d00278c05ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92700d00278c05ec$var$load("fviv5").then(()=>parcelRequire('d1j2S'));

});

parcelRegister("e5mYd", function(module, exports) {

let $a41359bbf51483d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a41359bbf51483d3$var$load("hEkXc").then(()=>parcelRequire('dnFPq'));

});

parcelRegister("dIcAj", function(module, exports) {

let $9fb9257e8f004e1e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9fb9257e8f004e1e$var$load("6oOC9").then(()=>parcelRequire('4WIcD'));

});

parcelRegister("iIKoF", function(module, exports) {

let $da10537d6882eb83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $da10537d6882eb83$var$load("le1sE").then(()=>parcelRequire('7DdDO'));

});

parcelRegister("jOmZE", function(module, exports) {

let $e6c485d61d80957f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6c485d61d80957f$var$load("eBoC7").then(()=>parcelRequire('hWRzS'));

});

parcelRegister("fFRNT", function(module, exports) {

let $b6946ba29168eee5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b6946ba29168eee5$var$load("bNv64").then(()=>parcelRequire('c7q37'));

});

parcelRegister("32noh", function(module, exports) {

let $2363b3de6d4c361f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2363b3de6d4c361f$var$load("bAoKR").then(()=>parcelRequire('6eH2E'));

});

parcelRegister("fxuYz", function(module, exports) {

let $b501f73eb9c01946$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b501f73eb9c01946$var$load("4Afgd").then(()=>parcelRequire('Plo13'));

});

parcelRegister("l3Eye", function(module, exports) {

let $f549556471decd0d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f549556471decd0d$var$load("cMubu").then(()=>parcelRequire('iY0zC'));

});

parcelRegister("f7ky6", function(module, exports) {

let $b0177311b6470e9f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b0177311b6470e9f$var$load("3fLE9").then(()=>parcelRequire('lqPAG'));

});

parcelRegister("7as9r", function(module, exports) {

let $537f4ddb2ec636fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $537f4ddb2ec636fd$var$load("8hOn0").then(()=>parcelRequire('85Nk7'));

});

parcelRegister("76QyX", function(module, exports) {

let $52d1ddccab26d8ad$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $52d1ddccab26d8ad$var$load("h4OCL").then(()=>parcelRequire('gdGRk'));

});

parcelRegister("4Qc7k", function(module, exports) {

let $38656afb586d425b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38656afb586d425b$var$load("bcQs2").then(()=>parcelRequire('eVsDT'));

});

parcelRegister("2MU1N", function(module, exports) {

let $207b8670a2090b06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $207b8670a2090b06$var$load("aBa7j").then(()=>parcelRequire('76Zjl'));

});

parcelRegister("4YZVZ", function(module, exports) {

let $3a0ccee1344f3378$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3a0ccee1344f3378$var$load("b544F").then(()=>parcelRequire('8JOK1'));

});

parcelRegister("it51F", function(module, exports) {

let $d71ed57ac31d7d73$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d71ed57ac31d7d73$var$load("K6fhx").then(()=>parcelRequire('5eTse'));

});

parcelRegister("1F6qu", function(module, exports) {

let $135e9ae57572fc2b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $135e9ae57572fc2b$var$load("gZU54").then(()=>parcelRequire('1OKs8'));

});

parcelRegister("hROdq", function(module, exports) {

let $d01e56aadfa3e1c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d01e56aadfa3e1c7$var$load("hlJc4").then(()=>parcelRequire('Xa5VS'));

});

parcelRegister("1LJw7", function(module, exports) {

let $149d7cfd5ce1c351$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $149d7cfd5ce1c351$var$load("4Wdqb").then(()=>parcelRequire('7W27q'));

});

parcelRegister("huY3L", function(module, exports) {

let $cbd3d3981dbe4b82$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cbd3d3981dbe4b82$var$load("k10Cs").then(()=>parcelRequire('6CeqQ'));

});

parcelRegister("kVYlY", function(module, exports) {

let $f3d7f2733d894d43$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f3d7f2733d894d43$var$load("g5LV7").then(()=>parcelRequire('88szQ'));

});

parcelRegister("8QxWk", function(module, exports) {

let $670d81cf18ad951a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $670d81cf18ad951a$var$load("1n8w9").then(()=>parcelRequire('8mq9f'));

});

parcelRegister("hVm6V", function(module, exports) {

let $d0c8e949da6b9da5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d0c8e949da6b9da5$var$load("2QtDQ").then(()=>parcelRequire('gOCry'));

});

parcelRegister("i2Gvh", function(module, exports) {

let $d2296231d9d45e0f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2296231d9d45e0f$var$load("i2vEA").then(()=>parcelRequire('8bOb4'));

});

parcelRegister("3rvZL", function(module, exports) {

let $281cb64eec2931e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $281cb64eec2931e6$var$load("f1B4n").then(()=>parcelRequire('03O98'));

});

parcelRegister("3A0MI", function(module, exports) {

let $29b557b82cced2b4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29b557b82cced2b4$var$load("l079e").then(()=>parcelRequire('eLabs'));

});


parcelRegister("3nDO6", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $8393a846181017db$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6YvRD = parcelRequire("6YvRD");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8393a846181017db$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $8393a846181017db$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8393a846181017db$var$importHelper(await (parcelRequire("1F8PS")));
        case 'da':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kk0Dg")));
        case 'de':
            return $8393a846181017db$var$importHelper(await (parcelRequire("dmjL7")));
        case 'en-GB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cfn7s")));
        case 'en-US':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2UBSA")));
        case 'en-XA':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8IIdi")));
        case 'en-XB':
            return $8393a846181017db$var$importHelper(await (parcelRequire("kACr1")));
        case 'en-ZZ':
            return $8393a846181017db$var$importHelper(await (parcelRequire("8uZhS")));
        case 'en':
            return $8393a846181017db$var$importHelper(await Promise.resolve((parcelRequire("6YvRD"))));
        case 'es':
            return $8393a846181017db$var$importHelper(await (parcelRequire("2OnQ5")));
        case 'et':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bwUqh")));
        case 'fi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("cxakJ")));
        case 'fr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7YB9E")));
        case 'hu':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lCzXr")));
        case 'it':
            return $8393a846181017db$var$importHelper(await (parcelRequire("gTZbf")));
        case 'ja':
            return $8393a846181017db$var$importHelper(await (parcelRequire("c4dvE")));
        case 'ko':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bIHhK")));
        case 'nb':
            return $8393a846181017db$var$importHelper(await (parcelRequire("eOFtl")));
        case 'nl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("hDqVC")));
        case 'pl':
            return $8393a846181017db$var$importHelper(await (parcelRequire("3OaWD")));
        case 'pt-BR':
            return $8393a846181017db$var$importHelper(await (parcelRequire("ghFPe")));
        case 'ro':
            return $8393a846181017db$var$importHelper(await (parcelRequire("lIhRt")));
        case 'ru':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9Y4Ru")));
        case 'sv':
            return $8393a846181017db$var$importHelper(await (parcelRequire("hdCEv")));
        case 'th':
            return $8393a846181017db$var$importHelper(await (parcelRequire("fYYyy")));
        case 'tr':
            return $8393a846181017db$var$importHelper(await (parcelRequire("bCm0G")));
        case 'uk':
            return $8393a846181017db$var$importHelper(await (parcelRequire("9robZ")));
        case 'vi':
            return $8393a846181017db$var$importHelper(await (parcelRequire("aG2Bm")));
        case 'zh-CN':
            return $8393a846181017db$var$importHelper(await (parcelRequire("949j6")));
        case 'zh-TW':
            return $8393a846181017db$var$importHelper(await (parcelRequire("7um3i")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6YvRD));
    }
};

});
parcelRegister("1F8PS", function(module, exports) {

let $136079612fc4e9f7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $136079612fc4e9f7$var$load("bv8GZ").then(()=>parcelRequire('74xff'));

});

parcelRegister("kk0Dg", function(module, exports) {

let $ecb62a7403f009af$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ecb62a7403f009af$var$load("cdeuH").then(()=>parcelRequire('hQIGt'));

});

parcelRegister("dmjL7", function(module, exports) {

let $9b9ca829d417e593$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9b9ca829d417e593$var$load("7gF8f").then(()=>parcelRequire('j9sSr'));

});

parcelRegister("cfn7s", function(module, exports) {

let $8ea8d1c489e562b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8ea8d1c489e562b7$var$load("djb49").then(()=>parcelRequire('4tVXT'));

});

parcelRegister("2UBSA", function(module, exports) {

let $21ee31c8724447e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21ee31c8724447e5$var$load("koawN").then(()=>parcelRequire('k7TQm'));

});

parcelRegister("8IIdi", function(module, exports) {

let $6594baac33897764$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6594baac33897764$var$load("6htQT").then(()=>parcelRequire('lIWyQ'));

});

parcelRegister("kACr1", function(module, exports) {

let $efd4fbc5ec1f9e1d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $efd4fbc5ec1f9e1d$var$load("fi75i").then(()=>parcelRequire('5QCdA'));

});

parcelRegister("8uZhS", function(module, exports) {

let $6300aa71c10ccf3e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6300aa71c10ccf3e$var$load("ksTQ6").then(()=>parcelRequire('4EAWY'));

});

parcelRegister("2OnQ5", function(module, exports) {

let $20c2be410e137536$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $20c2be410e137536$var$load("5CGnz").then(()=>parcelRequire('1PSNt'));

});

parcelRegister("bwUqh", function(module, exports) {

let $864e734815f334fe$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $864e734815f334fe$var$load("X0Jic").then(()=>parcelRequire('cNrRQ'));

});

parcelRegister("cxakJ", function(module, exports) {

let $9200951f82e878d2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9200951f82e878d2$var$load("9Oxgj").then(()=>parcelRequire('5L1ix'));

});

parcelRegister("7YB9E", function(module, exports) {

let $5ceaf51ff3e9db67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5ceaf51ff3e9db67$var$load("kAg8V").then(()=>parcelRequire('f4vYC'));

});

parcelRegister("lCzXr", function(module, exports) {

let $fbd90a0817a8740a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fbd90a0817a8740a$var$load("fM2oh").then(()=>parcelRequire('lmfGu'));

});

parcelRegister("gTZbf", function(module, exports) {

let $c4e13d90af3270d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c4e13d90af3270d3$var$load("xnqy2").then(()=>parcelRequire('J7CId'));

});

parcelRegister("c4dvE", function(module, exports) {

let $8c905673636be71f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8c905673636be71f$var$load("awkVi").then(()=>parcelRequire('iEu8X'));

});

parcelRegister("bIHhK", function(module, exports) {

let $888561520b0bebbf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $888561520b0bebbf$var$load("11DLa").then(()=>parcelRequire('lklBt'));

});

parcelRegister("eOFtl", function(module, exports) {

let $ac95e7b7a60cecfb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ac95e7b7a60cecfb$var$load("barSq").then(()=>parcelRequire('edhkG'));

});

parcelRegister("hDqVC", function(module, exports) {

let $cd6af79a32b1b8c7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cd6af79a32b1b8c7$var$load("a8heY").then(()=>parcelRequire('aFb9z'));

});

parcelRegister("3OaWD", function(module, exports) {

let $2c5e87fece611498$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2c5e87fece611498$var$load("6hlNE").then(()=>parcelRequire('bAPfw'));

});

parcelRegister("ghFPe", function(module, exports) {

let $bdaead80a9a43b5e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bdaead80a9a43b5e$var$load("2bqSD").then(()=>parcelRequire('c1E8Q'));

});

parcelRegister("lIhRt", function(module, exports) {

let $fceb8fee3c031379$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fceb8fee3c031379$var$load("j6IGj").then(()=>parcelRequire('88y6K'));

});

parcelRegister("9Y4Ru", function(module, exports) {

let $741d7d113b0b73b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $741d7d113b0b73b3$var$load("bJykp").then(()=>parcelRequire('8Rjw5'));

});

parcelRegister("hdCEv", function(module, exports) {

let $c891a2229252db84$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c891a2229252db84$var$load("dh2Er").then(()=>parcelRequire('6TlJn'));

});

parcelRegister("fYYyy", function(module, exports) {

let $ba2b6edb2f741171$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ba2b6edb2f741171$var$load("kyBJI").then(()=>parcelRequire('7Nysq'));

});

parcelRegister("bCm0G", function(module, exports) {

let $87545107d0c054d1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $87545107d0c054d1$var$load("eBLgB").then(()=>parcelRequire('1gaUd'));

});

parcelRegister("9robZ", function(module, exports) {

let $6df966c50dc10ee3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6df966c50dc10ee3$var$load("ahhGv").then(()=>parcelRequire('bcwM6'));

});

parcelRegister("aG2Bm", function(module, exports) {

let $7c5fd83975789152$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c5fd83975789152$var$load("1Zesg").then(()=>parcelRequire('7fZ9R'));

});

parcelRegister("949j6", function(module, exports) {

let $699bb4fd25605671$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $699bb4fd25605671$var$load("eLlpV").then(()=>parcelRequire('15VSW'));

});

parcelRegister("7um3i", function(module, exports) {

let $573c70dda0c9847c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $573c70dda0c9847c$var$load("bV8sS").then(()=>parcelRequire('dU88R'));

});


parcelRegister("kdvUL", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $a5b98d263d96b9ca$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8Mosz = parcelRequire("8Mosz");

var $eoZW1 = parcelRequire("eoZW1");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a5b98d263d96b9ca$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $a5b98d263d96b9ca$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $eoZW1.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("lgYjG")));
        case 'da':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aMvW6")));
        case 'de':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hhXZB")));
        case 'en-GB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("kYlvw")));
        case 'en-US':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("kMHjk")));
        case 'en-XA':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("2TtYJ")));
        case 'en-XB':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("gcbIg")));
        case 'en-ZZ':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6UJcw")));
        case 'en':
            return $a5b98d263d96b9ca$var$importHelper(await Promise.resolve((parcelRequire("8Mosz"))));
        case 'es':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("1Wy93")));
        case 'et':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Klw4")));
        case 'fi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("hzXCu")));
        case 'fr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("It92o")));
        case 'hu':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Ph0I")));
        case 'it':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cfFfg")));
        case 'ja':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("jyaSl")));
        case 'ko':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("f8elT")));
        case 'nb':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("7tONR")));
        case 'nl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("6Zb6O")));
        case 'pl':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("3AE5f")));
        case 'pt-BR':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("8z7BF")));
        case 'ro':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("GyNeb")));
        case 'ru':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5ONF5")));
        case 'sv':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5zENw")));
        case 'th':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("5IRx0")));
        case 'tr':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("adVJa")));
        case 'uk':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("bZV8f")));
        case 'vi':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("853SZ")));
        case 'zh-CN':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("aOyE3")));
        case 'zh-TW':
            return $a5b98d263d96b9ca$var$importHelper(await (parcelRequire("cBu0O")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8Mosz));
    }
};

});
parcelRegister("lgYjG", function(module, exports) {

let $f7c9e12e02706323$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7c9e12e02706323$var$load("1jsQH").then(()=>parcelRequire('fa8lP'));

});

parcelRegister("aMvW6", function(module, exports) {

let $7d9728ebd0cc0255$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d9728ebd0cc0255$var$load("deyvi").then(()=>parcelRequire('e3sAb'));

});

parcelRegister("hhXZB", function(module, exports) {

let $c9628f7bd61c0517$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c9628f7bd61c0517$var$load("6dERU").then(()=>parcelRequire('gch8x'));

});

parcelRegister("kYlvw", function(module, exports) {

let $f44a18250432e8da$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f44a18250432e8da$var$load("kTurq").then(()=>parcelRequire('8ptsW'));

});

parcelRegister("kMHjk", function(module, exports) {

let $f219e2f98c7e6fef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f219e2f98c7e6fef$var$load("fbIIm").then(()=>parcelRequire('a6GY6'));

});

parcelRegister("2TtYJ", function(module, exports) {

let $21b7f8f58a479391$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $21b7f8f58a479391$var$load("7l3it").then(()=>parcelRequire('8fxxk'));

});

parcelRegister("gcbIg", function(module, exports) {

let $bca6da459c328a88$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bca6da459c328a88$var$load("i64HJ").then(()=>parcelRequire('efBlj'));

});

parcelRegister("6UJcw", function(module, exports) {

let $508b08ff258adc64$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $508b08ff258adc64$var$load("j0PWv").then(()=>parcelRequire('ks6TI'));

});

parcelRegister("1Wy93", function(module, exports) {

let $16a5b1b54bc06544$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $16a5b1b54bc06544$var$load("dlmud").then(()=>parcelRequire('imT4f'));

});

parcelRegister("6Klw4", function(module, exports) {

let $4e97baa60f886ac0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4e97baa60f886ac0$var$load("7snhF").then(()=>parcelRequire('cQTYN'));

});

parcelRegister("hzXCu", function(module, exports) {

let $ccc3f3cf413db973$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ccc3f3cf413db973$var$load("cbkj0").then(()=>parcelRequire('j8AG8'));

});

parcelRegister("It92o", function(module, exports) {

let $085ab7b826eaff2f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $085ab7b826eaff2f$var$load("17m16").then(()=>parcelRequire('cdNFz'));

});

parcelRegister("6Ph0I", function(module, exports) {

let $4f84b372495070be$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4f84b372495070be$var$load("b4NO6").then(()=>parcelRequire('gPFiy'));

});

parcelRegister("cfFfg", function(module, exports) {

let $8eb6e12e32de23d0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8eb6e12e32de23d0$var$load("1K1Fj").then(()=>parcelRequire('dIMMS'));

});

parcelRegister("jyaSl", function(module, exports) {

let $e3b9a0ee8175e77b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3b9a0ee8175e77b$var$load("38sfA").then(()=>parcelRequire('css4w'));

});

parcelRegister("f8elT", function(module, exports) {

let $b042bc67bf906637$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b042bc67bf906637$var$load("bjmre").then(()=>parcelRequire('9R9u0'));

});

parcelRegister("7tONR", function(module, exports) {

let $5722a64fa2d6109b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5722a64fa2d6109b$var$load("asvK9").then(()=>parcelRequire('6DTdr'));

});

parcelRegister("6Zb6O", function(module, exports) {

let $51610e8e9990c64a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $51610e8e9990c64a$var$load("7v6wU").then(()=>parcelRequire('ceZMk'));

});

parcelRegister("3AE5f", function(module, exports) {

let $29d3d3a83b915225$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $29d3d3a83b915225$var$load("aEpRh").then(()=>parcelRequire('jtjwW'));

});

parcelRegister("8z7BF", function(module, exports) {

let $63c77e170fd2851d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $63c77e170fd2851d$var$load("3fuR9").then(()=>parcelRequire('l8CqS'));

});

parcelRegister("GyNeb", function(module, exports) {

let $07fee985e2aa8d66$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $07fee985e2aa8d66$var$load("bSjyK").then(()=>parcelRequire('fFbIU'));

});

parcelRegister("5ONF5", function(module, exports) {

let $43c82508b519f717$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $43c82508b519f717$var$load("fMrUo").then(()=>parcelRequire('hHfxK'));

});

parcelRegister("5zENw", function(module, exports) {

let $40efde36d68433dd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $40efde36d68433dd$var$load("9eNkX").then(()=>parcelRequire('2OLbL'));

});

parcelRegister("5IRx0", function(module, exports) {

let $42aa96001a33cb5b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $42aa96001a33cb5b$var$load("fTPgj").then(()=>parcelRequire('lSTN4'));

});

parcelRegister("adVJa", function(module, exports) {

let $7717e5be3b377e8d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7717e5be3b377e8d$var$load("h0uBE").then(()=>parcelRequire('74ATO'));

});

parcelRegister("bZV8f", function(module, exports) {

let $8bc1b571ad8da4cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8bc1b571ad8da4cf$var$load("lKa7i").then(()=>parcelRequire('3fixv'));

});

parcelRegister("853SZ", function(module, exports) {

let $5e21ce045e22b771$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e21ce045e22b771$var$load("9aufD").then(()=>parcelRequire('kafqC'));

});

parcelRegister("aOyE3", function(module, exports) {

let $7df972b1010b14c0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7df972b1010b14c0$var$load("gDiIK").then(()=>parcelRequire('19yAM'));

});

parcelRegister("cBu0O", function(module, exports) {

let $92d03884d22bdbde$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $92d03884d22bdbde$var$load("j9OUx").then(()=>parcelRequire('jSsWA'));

});


var $ff8eff1e9a27602f$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"bx5Ka\",\"AppSwitcherContent.266d067a.js\",\"i5eMd\",\"cs.2dd9440c.js\",\"4UPfH\",\"da.2b0a7cc7.js\",\"gd4qs\",\"de.67b8372f.js\",\"fviv5\",\"en-GB.856d654f.js\",\"hEkXc\",\"en-US.c2f93eaf.js\",\"6oOC9\",\"en-XA.b9ea4c73.js\",\"le1sE\",\"en-XB.4234a481.js\",\"eBoC7\",\"en-ZZ.694f1ac7.js\",\"bNv64\",\"es.eee7afa5.js\",\"bAoKR\",\"et.b46b672c.js\",\"4Afgd\",\"fi.253ab239.js\",\"cMubu\",\"fr.7d1945bd.js\",\"3fLE9\",\"hu.fda15b26.js\",\"8hOn0\",\"it.0b906733.js\",\"h4OCL\",\"ja.3589f908.js\",\"bcQs2\",\"ko.72640407.js\",\"aBa7j\",\"nb.93cc6e2d.js\",\"b544F\",\"nl.e7a58a33.js\",\"K6fhx\",\"pl.e33ba088.js\",\"gZU54\",\"pt-BR.f14db837.js\",\"hlJc4\",\"ro.968019e9.js\",\"4Wdqb\",\"ru.d141eb31.js\",\"k10Cs\",\"sv.66e5273d.js\",\"g5LV7\",\"th.80a6d5f0.js\",\"1n8w9\",\"tr.3b683a89.js\",\"2QtDQ\",\"uk.a497e182.js\",\"i2vEA\",\"vi.5604411e.js\",\"f1B4n\",\"zh-CN.4a59e25d.js\",\"l079e\",\"zh-TW.da6c4f6b.js\",\"bv8GZ\",\"cs.b8d1c1b1.js\",\"cdeuH\",\"da.42823f82.js\",\"7gF8f\",\"de.8842c040.js\",\"djb49\",\"en-GB.70cd0dcf.js\",\"koawN\",\"en-US.8577a1a6.js\",\"6htQT\",\"en-XA.98171bdb.js\",\"fi75i\",\"en-XB.dbd65aa8.js\",\"ksTQ6\",\"en-ZZ.4f7eefe8.js\",\"5CGnz\",\"es.98f8e90e.js\",\"X0Jic\",\"et.155c1ee0.js\",\"9Oxgj\",\"fi.f2f3389c.js\",\"kAg8V\",\"fr.368a32d8.js\",\"fM2oh\",\"hu.f2f9ae82.js\",\"xnqy2\",\"it.351ab003.js\",\"awkVi\",\"ja.99d2f833.js\",\"11DLa\",\"ko.8aeaf96b.js\",\"barSq\",\"nb.4503e9a5.js\",\"a8heY\",\"nl.6070b16e.js\",\"6hlNE\",\"pl.9a5b0b0f.js\",\"2bqSD\",\"pt-BR.10f91e79.js\",\"j6IGj\",\"ro.b5d74be6.js\",\"bJykp\",\"ru.2a448b30.js\",\"dh2Er\",\"sv.e6031ecb.js\",\"kyBJI\",\"th.ea68a7ea.js\",\"eBLgB\",\"tr.a4d35ce1.js\",\"ahhGv\",\"uk.13d42b80.js\",\"1Zesg\",\"vi.e3d9da82.js\",\"eLlpV\",\"zh-CN.914fb213.js\",\"bV8sS\",\"zh-TW.90b55434.js\",\"1jsQH\",\"cs.688247af.js\",\"deyvi\",\"da.ce01a3f4.js\",\"6dERU\",\"de.196d0286.js\",\"kTurq\",\"en-GB.16aba98a.js\",\"fbIIm\",\"en-US.0fcdf1ae.js\",\"7l3it\",\"en-XA.d0c85306.js\",\"i64HJ\",\"en-XB.c2b1d8a6.js\",\"j0PWv\",\"en-ZZ.3edc5475.js\",\"dlmud\",\"es.a37dad44.js\",\"7snhF\",\"et.20d4d799.js\",\"cbkj0\",\"fi.c129a5d2.js\",\"17m16\",\"fr.d48d2214.js\",\"b4NO6\",\"hu.d63219d9.js\",\"1K1Fj\",\"it.68b18a63.js\",\"38sfA\",\"ja.05e83d89.js\",\"bjmre\",\"ko.5d08c8ec.js\",\"asvK9\",\"nb.b60c8cb7.js\",\"7v6wU\",\"nl.d417f24d.js\",\"aEpRh\",\"pl.26cf010d.js\",\"3fuR9\",\"pt-BR.b55187ea.js\",\"bSjyK\",\"ro.8940bbdc.js\",\"fMrUo\",\"ru.f0bbf79a.js\",\"9eNkX\",\"sv.12cce2b0.js\",\"fTPgj\",\"th.4d360fb6.js\",\"h0uBE\",\"tr.a1624066.js\",\"lKa7i\",\"uk.38ddf7bc.js\",\"9aufD\",\"vi.4cc44e33.js\",\"gDiIK\",\"zh-CN.268ccaa6.js\",\"j9OUx\",\"zh-TW.f59f4c5f.js\"]"));


//# sourceMappingURL=AppSwitcherContent.266d067a.js.map
